import React, { useEffect, useState } from "react";
import ApiClient from "../../common/ApiClient";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

import Typography from "@mui/material/Typography";
import AlertMessage from "../../AlertMessage";

import Failure from "../../../images/Failure.png";
import Pending from "../../../images/Pending.png";
import { isTimeUp } from "../../Helper";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Declaration = ({ formData }) => {
  const { id = null, response = null } = useParams();
  const dashboardnavi = useNavigate();
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    checkbox5: false,
  });
  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCheckboxes({
      ...checkboxes,
      [id]: checked,
    });
  };
  const allChecked = Object.values(checkboxes).every(Boolean);
  const { putRequest, getRequest, deleteRequest } = ApiClient();

  const [paymentMessage, setPaymentMessage] = useState(null);
  const [paymentResponse, setPaymentResponse] = useState(response);
  const [alertData, setAlertData] = useState({
    heading: "",
    content: "",
  });
  const generatePaymentMsg = async () => {
    let predata = await putRequest("go_to_payment", { last_id: id });

    if (predata.status) {
      // console.log(predata.data.msg)
      setPaymentMessage(predata.data.msg);
    }
    //  console.log({ paymentMessage });
  };
  const search = useLocation().search;
  const daata = new URLSearchParams(search).get("response");

  const paymentResponseLastTransation = async () => {
    if (daata === "pending") {
      setAlertData({
        heading: "Payment Status",
        content: (
          <>
            <p style={{ display: "flex", justifyContent: "center" }}>
              <img src={Pending} alt="" width="60px" height="60px" />{" "}
            </p>
            <h4 style={{ display: "flex", justifyContent: "center" }}>
              Transaction Pending
            </h4>
            <Typography gutterBottom>
              <p
                style={{ textAlign: "center", marginTop: "10px" }}
                className="text-center"
              >
                {" "}
                Your transaction is currently in pending. We're working to
                process it as quickly as possible. Thanks for your patience!{" "}
              </p>
            </Typography>
          </>
        ),
      });
      handleClickOpen();
    }
    if (daata === "failed") {
      setAlertData({
        heading: "Payment Status",
        content: (
          <>
            <p style={{ display: "flex", justifyContent: "center" }}>
              <img src={Failure} alt="" width="78px" height="78px" />{" "}
            </p>
            <h4 style={{ display: "flex", justifyContent: "center" }}>
              Payment Failed
            </h4>
            <Typography gutterBottom>
              <p
                style={{ textAlign: "center", marginTop: "10px" }}
                className="text-center"
              >
                {" "}
                We regret to inform you that your payment has failed to process.
                Please review your payment details and try again.{" "}
              </p>
            </Typography>
          </>
        ),
      });
      handleClickOpen();
    }
  };
  useEffect(() => {
    paymentResponseLastTransation();
    generatePaymentMsg();
    // console.log({ paymentdata: process.env.REACT_APP_PAYMENT_URL })
    // Load BillDesk script dynamically
    const script = document.createElement("script");
    // script.src = 'https://uat.billdesk.com/payments-checkout-widget/src/app.bundle.js';//'https://pgi.billdesk.com/payments-checkout-widget/src/app.bundle.js';
    script.src =
      "https://pgi.billdesk.com/payments-checkout-widget/src/app.bundle.js";
    script.async = true;
    script.onload = () => {
      // Script has been loaded, now you can use bdPayment
      // console.log('BillDesk script loaded');
    };
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const processToPay = async () => {
    // console.log({ SERVER_URL: process.env.REACT_APP_BASE_URL });
    console.log({ paymentMessage })
    if (!paymentMessage) {
      await generatePaymentMsg();
      // console.log(" error occurred ");
    }
    if (window.bdPayment) {
      // console.log('Pay Msg : : ', paymentMessage);
      window.bdPayment.initialize({
        msg: paymentMessage, //"NFDCLTD|NFAI-FCM-64|NA|1770.00|NA|NA|NA|INR|NA|R|nfdcltd|NA|NA|F|abhisheksrivastava0022@gmail.com|7985430710|NFAI|Abhishek Srivastava|NFAI-FCM-64|NA|NA|NA|4449748D363C5227F532121F004C3CFBD09F9AEBCCCE7334F7C5FB61F77E2821",
        options: {
          enableChildWindowPosting: true,
          enablePaymentRetry: true,
          retry_attempt_count: 2,
        },
        callbackUrl: `${process.env.REACT_APP_BASE_URL}/payment-response`,
      });
    } else {
      console.error("BillDesk script not loaded yet");
    }
  };
  const ipform_expiry_date = process.env.REACT_APP_IP_FORM_EXPIRY_DATE;
  const iptimeUp = isTimeUp(ipform_expiry_date);
  const timeUpHandler = () => {
    if (iptimeUp) {
      alert("Time is up! You can no longer proceed.");
      dashboardnavi("/dashboard/ip");
    } else {
      // You can show an alert or handle the "time up" condition differently here
      processToPay();
    }
  };
  const fetchPaymentStatus = async () => {
    try {
      // const response = await axios.get('http://localhost:3001/api/payment/status'); // Your endpoint to check payment status
      //setPaymentStatus(response.data);
    } catch (error) {
      console.error("Error fetching payment status:", error);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    // console.log("handleClickOpen");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <h5>
        Declaration <span className="text-danger">*</span>
      </h5>
      <form>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-lg-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkbox1"
                  checked={checkboxes.checkbox1}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="checkbox1">
                  <p class="declar">
                    I/We have No Objection for screening of this film for jury
                    or any of their panels, for non-commercial public shows of
                    the film as part of promotion of quality Indian Cinema
                    within India and abroad in film festivals/special
                    expositions organized/supported by the National Film
                    Development Corporation in any digital format as well as
                    promotion of the film through the use of film stills/posters
                    and trailers/visual clips.
                  </p>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-lg-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkbox2"
                  checked={checkboxes.checkbox2}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="checkbox2">
                  <p class="declar">
                    I/We also assure that this No Objection to the NFDC will
                    remain valid not-withstanding any rights assigned by me/us
                    to any other individual/organization for screening the film
                    in any territory on commercial/non-commercial basis in
                    future.
                  </p>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-lg-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkbox3"
                  checked={checkboxes.checkbox3}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="checkbox3">
                  <p class="declar">
                    I/We declare that I/We have read the Indian Panorama
                    Regulations and accept them without reservation in
                    particular.
                  </p>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-lg-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkbox4"
                  checked={checkboxes.checkbox4}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="checkbox4">
                  <p class="declar">
                    I/We note the condition of Regulations 8.2 stipulating that
                    my/our entry will be rejected unless the entry form
                    alongwith all the required material including the DCP/ or
                    Pendrive is received by the National Film Development
                    Corporation on or before 31.08.2026 till 6:00 PM.
                  </p>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-lg-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkbox5"
                  checked={checkboxes.checkbox5}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="checkbox5">
                  <p class="declar">
                    I/We certify that the film entered is not a
                    Dubbed/Revised/Remake/Re-edited version of a film and has
                    not been submitted earlier. And has not infringed any
                    copyright in any manner whatsoever.
                  </p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-lg-12">
            <h5>
              Entry Fees:{" "}
              {formData.category == 1 ? (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 11,800/-
                </span>
              ) : formData.category == 2 ? (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 3,540/-
                </span>
              ) : formData.category == 3 ? (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 11,800/-
                </span>
              ) : formData.category == 4 ? (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 11,800/-
                </span>
              ) : (
                ""
              )}
              &nbsp;{" "}
              <span
                style={{
                  color: "#1c5768",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                (For{" "}
                {formData.category == 1
                  ? "Feature Film"
                  : formData.category == 2
                    ? "Non-feature Film"
                    : formData.category == 3
                      ? "Best Debut Director of Indian Feature Film"
                      : formData.category == 4
                        ? "New Horizon Feature Film"
                        : ""}
                )
              </span>
              {/* {formData.category == 1 ? (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 11800/-
                </span>
              ) : (
                <span
                  style={{
                    color: "#1c5768",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  INR 3540/-
                </span>
              )} */}
              {/* <span style={{ color: "#1c5768", fontSize: "28px", fontWeight: "500" }}>INR 11800/-</span> */}
            </h5>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-12 col-lg-12">
            <p
              className="text-uppercase"
              style={{ color: "#FF0000", fontWeight: "500" }}
            >
              Note: check all the details of form before final submission
            </p>
          </div>
        </div>
      </form>
      <button
        className="btn btn-success"
        onClick={timeUpHandler}
        disabled={!allChecked}
      >
        Pay & Submit
      </button>

      <AlertMessage
        handleClickOpen={handleClickOpen}
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        data={alertData}
      />
    </>
  );
};

export default Declaration;
